<template>

    <div class="lc">

        <div class="round">

            <img src="/img/newsletters-v2/party-favor.svg">

        </div>

        <p class="title-baseSemibold mt__16">{{$t('sorting_mail_title')}}</p>

        <p class="text-baseRegular mt__8">{{$t('sorting_mail_text')}}</p>

    </div>

</template>

<script>

import Tag from '../../../modules/tag'

export default {

    name: 'later-card',

    mounted() {
        Tag.infoAll(this, 'sort_later')
    }

}

</script>

<style lang="scss" scoped>

.lc {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background: linear-gradient(137deg, #78CEED 0.86%, #9DBADD 100%);
    padding: 16px;

    .round {
        width: 56px;
        height: 56px;
        border-radius: 56px;
        background-color: $alice-blue;
        overflow: hidden;
        display: flex;

        > img {
            width: 42px;
            object-fit: contain;
        }
    }
}

</style>
